<template>
  <EUIDialogWrapper
    :class="[$options.name, _themeClass]"
    ref="dialog"
    @hide="onDialogHide"
    v-bind="_mergedProps"
  >
    <div class="items-center q-px-lg">
      <div :class="['row q-mb-md full-width items-center justify-center']">
        <QIcon
          v-if="_mergedProps.labelIcon"
          size="25px"
          :name="_mergedProps.labelIcon"
          :color="_mergedProps.labelIconColor"
          class="q-mr-sm"
        />
        <span
          :class="['text-weight-medium text-grey-10 eui-heading']"
          v-if="_mergedProps.label"
        >
          {{ _mergedProps.label }}
        </span>
      </div>
      <div :class="['q-mb-md text-message full-width text-center']">
        <p>
          Your budget and actual comparison is a comparison between the monthly budget set for your Novated Lease
          and the actual payments made towards your vehicle running costs. All amounts are exclusive of GST.
        </p>
        <br>
        <p>
          The comparison <strong>DOES NOT</strong> factor in the payment status of the invoices we have issued to your Employer,
          nor the payroll deductions that have been taken from your pay for the cost of your lease to date.
        </p>
        <br>
        <p>
          FleetPartners will soon issue you a monthly statement containing payment information
          to give you an overall balance as at the time issued.
        </p>
        <br>
        <p>
            While FleetPartners aims to ensure the accuracy of the information presented, some data has been supplied by third parties.
            As per the terms and conditions of your lease, the Lessee is responsible for all expenses incurred in excess of the budgeted
            vehicle running costs, as reconciled and determined by FleetPartners when the novation ends.
            Any enquiries should be directed to FleetPartners on <strong>1300 666 001</strong>.
        </p>
      </div>
      <p
        :class="['q-mb-md text-message full-width text-center']"
        v-if="_mergedProps.message && !_mergedProps.html"
      >
        {{ _mergedProps.message }}
      </p>
      <p
        :class="['q-mb-md text-message full-width text-center']"
        v-if="_mergedProps.message && _mergedProps.html"
        v-html="_mergedProps.message"
      ></p>
      <div :class="['row q-col-gutter-md q-mb-md justify-center']">
        <div v-if="_mergedProps.cancelText" :class="actionSize">
          <EUIBtn
            :eui-theme="_appliedTheme"
            class="full-width"
            :label="_mergedProps.cancelText"
            @click.stop="hide"
            optional
            outline
          />
        </div>
        <div v-if="_mergedProps.okText" :class="actionSize">
          <EUIBtn
            :eui-theme="_appliedTheme"
            class="full-width"
            :label="_mergedProps.okText"
            :color="_mergedProps.okColor"
            @click.stop="ok"
          />
        </div>
        <slot name="actions" />
      </div>
    </div>
  </EUIDialogWrapper>
</template>

<script>
import EUITheme from '@eui-mixin/theme';
import EUIDialogWrapper from '@eui-molecule/dialog-wrapper';
import EUIDialogMixin from '@eui-mixin/dialog';
import EUIBtn from '@eui-atom/btn';
import { dom, QIcon } from 'quasar';
import { euiThemes } from '@eui-mixin/theme';

const themeDefaults = {
  common: {
    displayHideAction: true,
    imgWidth: '256px',
    actionsGrowBreakpoint: 400,
    actionsGrow: false,
    okColor: 'primary',
  },
  themes: {
    [euiThemes.customer]: {},
    [euiThemes.corporate]: {},
  },
};

export default {
  name: 'BudgetWarningDialog',
  mixins: [EUITheme, EUIDialogMixin],
  props: {
    label: String,
    labelIcon: String,
    labelIconColor: String,
    message: String,
    cancelText: String,
    okText: String,
    okColor: String,
    actionsGrowBreakpoint: Number,
    actionsGrow: {
      type: Boolean,
      default: undefined,
    },
    html: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      themeDefaults,
      largerThanActionsGrowBreakpoint: false,
    };
  },
  computed: {
    actionSize() {
      if (this.largerThanActionsGrowBreakpoint) {
        return;
      }
      return this._mergedProps.actionsGrow ? 'col-grow' : 'col-6';
    },
  },
  async mounted() {
    await this.$nextTick();
    const dialogCard = this?.$refs?.dialog?.$refs?.dialogCard;

    if (dialogCard && dialogCard.$el) {
      if (dom.width(dialogCard.$el) > this._mergedProps.actionsGrowBreakpoint) {
        this.largerThanActionsGrowBreakpoint = true;
      }
    }
  },
  components: {
    EUIDialogWrapper,
    EUIBtn,
    QIcon,
  },
};
</script>

<style lang="sass" scoped></style>
